import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import TextField from '@mui/material/TextField';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../../utilities/FormPageHeader';
import { FormControl, FormControlLabel, FormGroup, Stack, Switch, Typography } from '@mui/material';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkBlankSpace, checkNumber, checkSpecialChar } from '../../utilities/FormValidation';

const VoucherTypeForm = () => {
    const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucherTypes}`;
    const voucherTypeurl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucherType}`;

    const [tabValue, setTabValue] = useState(0);
    const params = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const [shortKey, setShortKey] = useState("");
    const [description, setDescription] = useState("");
    const [snackState, setSnackState] = useState(false);
    const [active, setActive] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const [saveDisable, setSaveDisable] = useState(true)
    const [editData, setEditData] = useState();

    const handleSubmit = async () => {
        setCheckSubmit(true);
        let model = {
            shortKey: shortKey ,
            description: description,
        };

        try {
            if (params.id) {
                if (shortKey && description &&
                    !validError.shortKey && !validError.description) {
                    await OAuthService.updateData(url, params.id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/voucherTypes')},800);
                }
            } else {
                if (shortKey && description &&
                    !validError.shortKey && !validError.description) {
                    await OAuthService.addData(voucherTypeurl+ '/saveVoucherType', model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/voucherTypes')},800);
                }
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }
    }

    /**
        * Tab Change
    */
    function handleTabChange(event, value) {
        setTabValue(value);
    }

    const getVoucherType = async () => {
        try {
            const result = await OAuthService.getEditData(url, params.id);
            const voucherTypes = result.data;
            setShortKey(voucherTypes.shortKey);
            setDescription(voucherTypes.description);
            setEditData(voucherTypes);
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    useEffect(() => {
        if (params.id) {
            getVoucherType();
            setHideDelete(false)
        }
    }, []);

    const handleDelete = async () => {
        try {
            if (params.id) {
                await OAuthService.deleteData(url, params.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
            }
        } catch (error) {
            console.log('error', error)
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }
        setTimeout(() => { navigate('/voucherTypes')},800);
    }

    const handleChangeDescription =(e)=>{
        setDescription(e.target.value);
        // setValidError({...validError, description: checkSpecialChar(e.target.value) })
    }

    const handleCancel = () => {
        navigate('/voucherTypes')
    }

    useEffect(() => {
        if (description.trim() && shortKey && !validError.shortKey && !validError.description) {
            if(editData){
                if(description !== editData.description || shortKey !== editData.shortKey){
                    setSaveDisable(false);
                }else{
                    setSaveDisable(true);
                }                
            }else{                
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    },[description,shortKey,validError,editData]);

    return (
        <div className="w-full overflow-scroll">
            <FormPageHeader
                componentName="DeliveryTerms"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                currentPage={params.id ? "Update Voucher Type" : "Add Voucher Type"}
                parentBreadcrumbData={[{ pageName: 'Voucher Type List', pageLink: '/voucherTypes' }]}
                error={error}                
                successMsg={successMsg}
                snackState={snackState}
                hideDelete={hideDelete}
                handleCancel={handleCancel}
                saveDisable={saveDisable}
            >
                <Tabs
                    value={tabValue}
                    textColor="inherit"
                    onChange={handleTabChange}
                    indicatorColor="secondary"
                    sx={{ color: "yellow" }}
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">
                <FormControl
                    // ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className={tabValue !== 0 ? 'hidden' : ''}>
                    <Stack className="mb-16">
                            <label>*Short Key</label>
                            <TextField
                                type="text"
                                name="shortKey"
                                required
                                value={shortKey}
                                error={(checksubmit && !shortKey) || validError.shortKey ? true : false}
                                helperText={(checksubmit && !shortKey) ? "This field is required" : validError.shortKey}
                                onChange={(e) => {setShortKey(e.target.value); setValidError({...validError, shortKey: checkSpecialChar(e.target.value)})}}
                                variant="outlined"
                                inputProps={{
                                    maxLength: 2
                                }}
                            />
                        </Stack>
                        <Stack className="mb-16">
                            <label>*Description</label>
                            <TextField
                                type="text"
                                name="description"
                                value={description}
                                error={(checksubmit && !description) || validError.description ? true : false}
                                helperText={(checksubmit && !description) ? "This field is required" : validError.description}
                                onChange={handleChangeDescription}
                                className="select"
                            />
                        </Stack>
                    </div>
                </FormControl>
            </div>
        </div>
    )
}

export default VoucherTypeForm